<visio-card
  [background]="'rgb(var(--surface-container-low))'"
  [useContainerWidth]="true"
  [title]="cardTitle()"
>
  <div class="schedule-rule-card-container">
    <div class="card-fields">
      <div class="field-info">
        <span class="field-label">Requisitos de agendamento</span>
        @if (isEditingRequirements()) {
          <div class="requirements-edit">
            <textarea
              class="requirements-input"
              [value]="editedRequirements()"
              (input)="editedRequirements.set($any($event.target).value)"
              (keydown.escape)="cancelEditRequirements()"
            ></textarea>
            <div class="requirements-actions">
              <visio-icon-button
                [icon]="'save-icon'"
                [description]="'Salvar'"
                [descriptionPosition]="'bottom'"
                (click)="saveRequirements()"
              ></visio-icon-button>
              <visio-icon-button
                [icon]="'close-icon'"
                [description]="'Cancelar'"
                [descriptionPosition]="'bottom'"
                (click)="cancelEditRequirements()"
              ></visio-icon-button>
            </div>
          </div>
        } @else {
          <div class="requirements-display">
            <span class="field-value">{{ scheduleRule().schedule_requirements || '-' }}</span>
            <visio-icon-button
              [icon]="'edit-icon'"
              [description]="'Editar requisitos'"
              [descriptionPosition]="'bottom'"
              (click)="startEditRequirements()"
            ></visio-icon-button>
          </div>
        }
      </div>

      <div class="field-info">
        <span class="field-label">CS Responsável</span>
        <span class="field-value">{{ userName() || '-' }}</span>
      </div>

      <div class="field-info">
        <span class="field-label"># Dias</span>
        <span class="field-value">{{ scheduleRule().days_amount }}</span>
      </div>

      <div class="field-info weekday-compact">
        <span class="field-label">Dias da semana</span>
        <div class="weekday-compact-group">
          @for (weekday of weekdays; track weekday.index) {
            <span
              class="weekday-chip"
              [class.active]="isWeekdayChecked(weekday.key)"
              [class.disabled]="isWeekdayDisabled(weekday.key)"
              [title]="getTooltipText(weekday.index)"
              (click)="toggleWeekday(weekday.index)"
            >{{ weekday.label }}</span>
          }
        </div>
      </div>

      <div class="field-info">
        <span class="field-label">Última atualização</span>
        <span class="field-value">{{ updated_at() }}</span>
      </div>
    </div>

    <visio-switch
      [checked]="scheduleRule().active"
      [isDisabled]="switchDisabled()"
      (change)="toggleActive.emit($event)"
    ></visio-switch>

    <visio-icon-button
      [icon]="'store-icon'"
      [description]="'Atualizar'"
      [descriptionPosition]="'bottom'"
      (click)="requestUpdateFromAdmin.emit()"
    ></visio-icon-button>
  </div>
</visio-card>
